export const GRID_LAYOUT_STORE_NAME = '@gridLayout';

export enum LayoutSizes {
  lg = 'lg',
  md = 'md',
  sm = 'sm',
  xs = 'xs',
  xxs = 'xxs',
}

export const cols = { lg: 16, md: 12, sm: 8, xs: 4, xxs: 2 };
export const breakpoints = { lg: 1200, md: 1120, sm: 768, xs: 650, xxs: 0 };

export enum LayoutActionType {
  drag = 'drag',
  resize = 'resize',
}
